export default __webpack_public_path__ + "static/media/EvoESG-blk.a1100e02.png";